import router from "@/router/index";
import * as model from "@/model/prd/qualityMgt/qualityItemConfig/QualityItem";
import {
    newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.QualityItem(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
    }) //TODO load at the application start

    .withActions({

        QualityItemNew() {
            router.push('/prd/qualityItem/add');

        },

        View(context, entity) {
            context.dispatch("qualityItemDetails/qualityItemStatus", entity, {
                root: true
            });
            router.push({
                path: '/prd/qualityItemDetails',
                query: {
                    id: entity.id
                }
            });

        }


    })
    .buildStore()